import { useEffect, useRef } from "react"
import { useStoreState } from "easy-peasy"
import { useNavigate } from "react-router-dom"

export function useIdleTimeout() {
	const LoggedIn = useStoreState((state) => state.LoggedIn)
	const Token = useStoreState((state) => state.Token)
	const navigate = useNavigate()
	const timerRef = useRef(null)

	useEffect(() => {
		if (!LoggedIn || !Token.timeout) return

		const ms = Token.timeout * 60 * 1000

		const resetTimer = () => {
			clearTimeout(timerRef.current)
			timerRef.current = setTimeout(() => {
				navigate("/logout")
			}, ms)
		}

		const events = ["mousemove", "keydown", "mousedown", "touchstart", "scroll"]
		events.forEach((e) => window.addEventListener(e, resetTimer))
		resetTimer()

		return () => {
			clearTimeout(timerRef.current)
			events.forEach((e) => window.removeEventListener(e, resetTimer))
		}
	}, [LoggedIn, Token.timeout])
}
